import masterData from '../masterData';

const getSearchQuery = (value) => {
  if (value && value.condition) {
    const condition = value.condition;
    const searchParams = new URLSearchParams();
    for (const key of Object.keys(condition)) {
      if (Array.isArray(condition[key])) {
        if (condition[key].length > 0) {
          searchParams.append(key, "(" + condition[key].join('.') + ")")
        }
      } else if (condition[key]) {
        searchParams.append(key, condition[key])
      }
    }
    return "?" + searchParams.toString()
      .replace(/%28/g, '(')
      .replace(/%29/g, ')')
  } else {
    return "";
  }
}
/* eslint-disable complexity */
export const getUrl = (value) => {
    const condition = Object.assign({}, value && value.condition);
    const pref = condition.pref ? masterData.pref.byId[condition.pref] : null;
    if (pref) {
      delete condition.pref;
    }
    const city =
      condition.city && condition.city.length === 1 && pref
        ? masterData.city.byPrefAndSlug[pref.prefId][condition.city[0]]
        : null;
    const line = condition.line && condition.line.length === 1 && masterData.line.bySlug[condition.line[0]];
    const station = condition.station && condition.station.length === 1 && masterData.station.byId[condition.station[0]];
    console.log('line = ', line);
    console.log('station = ', station);

    let path = "";
    if (pref && city && city.districtSlug) {
      const baseCity = masterData.city.byPrefAndSlug[pref.prefId][city.baseSlug];
      path = `/${pref && pref.slug}/${baseCity.slug}/${city.districtSlug}/`;
      delete condition.city;
    } else if (!pref && station && line) {
      path = `/line-${line.slug}/${station.slug}/`;
      delete condition.line;
      delete condition.station;
    } else if (!pref && line) {
      path = `/line-${line.slug}/`;
      delete condition.line;
    } else if (pref && station && line) {
      path = `/${pref && pref.slug}/line-${line.slug}/${station.slug}/`;
      delete condition.line;
      delete condition.station;
    } else if (pref && line) {
      path = `/${pref && pref.slug}/line-${line.slug}/`;
      delete condition.line;
    } else if (pref && city) {
      path = `/${pref && pref.slug}/${city.slug}/`;
      delete condition.city;
    } else if (pref) {
      path = `/${pref && pref.slug}/list/`;
    } else {
      path = `/list/`;
    }
    Object.keys(condition).forEach(key => {
      if (condition[key] == null) {
        delete condition[key];
      }
    })
    return `${path}${getSearchQuery(Object.keys(condition).length && { condition })}`;
}
export const getAssetUrl = (asset) => {
  const pref = masterData.pref.byId[asset.pref];
  const city = pref && asset.city && masterData.city.byPrefAndSlug[pref.prefId][asset.city];
  if (city && city.baseSlug) {
    return `/${pref && pref.slug}/${city.baseSlug}/${city.districtSlug}/detail/${asset.assetId}/`;
  } else {
    return `/${pref && pref.slug}/${city && city.slug}/detail/${asset.assetId}/`;
  }
}

getUrl.injects = ['city', 'pref'];



// WEBPACK FOOTER //
// ./lib/masterUtil/getUrl.js